var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-header flex-row-between shadow"},[_c('img',{staticClass:"index-img",attrs:{"src":_vm.indexImgSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }